// auto setting
export const TypeAutoSectionFilledItemColorRules = Object.freeze({
    fill: {
        idle: {
            default: 'vibrant'
        },
        hover: {
            default: 'contrast'
        }
    },
    text: {
        idle: {
            default: 'background',
            fallbacks: ['contrast'],
            relativeToKey: {type: 'fill', state: 'idle'}
        },
        hover: {
            default: 'background',
            fallbacks: ['contrast'],
            relativeToKey: {type: 'fill', state: 'hover'}
        }
    },
})

export const TypeAutoSectionOutlinedItemColorRules = Object.freeze({
    fill: {
        idle: {
            default: 'background'
        },
        hover: {
            default: 'background'
        }
    },
    outline: {
        idle: {
            default: 'vibrant'
        },
        hover: {
            default: 'contrast'
        }
    },
    text: {
        idle: {
            default: 'contrast'
        },
        hover: {
            default: 'contrast'
        }
    },
})

export const TypeAutoSectionProcessStepColorRules = Object.freeze({
    fill: {
        active: {
            default: 'contrast'
        }
    },
    outline: {
        idle: {
            default: 'contrast',
        },
    },
    text: {
        idle: {
            default: 'contrast',
        },
        active: {
            default: 'selected',
        }
    }
})

// custom setting
export const TypeCustomSectionFilledItemColorRules = Object.freeze({
    fill: {
        idle: {
            default: 'selected',
        },
        hover: {
            default: 'selected',
        }
    },
    text: {
        idle: {
            default: 'background',
        },
        hover: {
            default: 'background',
        }
    },
})

export const TypeCustomSectionOutlinedItemColorRules = Object.freeze({
    fill: {
        idle: {
            default: 'background'
        },
        hover: {
            default: 'background'
        }
    },
    outline: {
        idle: {
            default: 'selected'
        },
        hover: {
            default: 'selected'
        }
    },
    text: {
        idle: {
            default: 'selected'
        },
        hover: {
            default: 'selected'
        }
    },
})

export const TypeCustomSectionProcessStepColorRules = Object.freeze({
    text: {
        active: {
            default: 'selected',
        }
    }
})